import { View } from 'react-native';
import { Section } from './Section';
import { SECTION_DATA } from './data';
import ProductInformations from '../ProductInformations/ProductInformations';

function AboutNeolexon() {
  return (
    <View className="flex-1 w-full p-4">
      {SECTION_DATA.map((section, index) => {
        const hasChildren = !!section.children;
        return (
          <Section key={index} title={section.title} content={section.content}>
            {hasChildren ? (
              <section.children.Component
                {...section.children.componentProps}
              ></section.children.Component>
            ) : null}
          </Section>
        );
      })}
      <ProductInformations />
    </View>
  );
}

export default AboutNeolexon;
